import { memo } from "react";
import { Box } from "@mui/material";

import Flx from "../../../../../components/layout/Flx";
import Txt from "../../../../../components/typography/Txt";

import {
  PALETTE,
  FONT_SERIF,
  FONT_MONO,
  DocCard,
} from "./_shared";

// eslint-disable-next-line no-unused-vars
const DocumentChecklistCard = ({ docCards, docTotals, isDscr, isConstruction }) => (
  <Box>
    <Flx
      sx={{
        alignItems: "baseline",
        mb: "20px",
        pb: "14px",
        flexWrap: "wrap",
        mt: 5,
      }}
      g={1.75}
      borderBottom={`1px solid ${PALETTE.line}`}
    >
      <Txt
        component="h2"
        sx={{
          fontFamily: FONT_SERIF,
          fontWeight: 500,
          fontSize: 22,
          letterSpacing: "-0.015em",
          m: 0,
          color: PALETTE.ink,
        }}
      >
        Document checklist
      </Txt>
      <Txt
        sx={{
          fontSize: 11,
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          color: PALETTE.ink3,
          fontFamily: FONT_MONO,
        }}
      >
        {docTotals.done} of {docTotals.total} received
      </Txt>
      {isConstruction && (
        <Box
          sx={{
            ml: "auto",
            fontSize: 11,
            background: PALETTE.warnSoft,
            color: PALETTE.warn,
            px: "10px",
            py: "4px",
            borderRadius: "4px",
            textTransform: "uppercase",
            letterSpacing: "0.06em",
            fontWeight: 500,
            fontFamily: FONT_MONO,
          }}
        >
          Construction product
        </Box>
      )}
    </Flx>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          md: "repeat(2, minmax(0, 1fr))",
          lg: "repeat(3, minmax(0, 1fr))",
        },
        gap: 2,
      }}
    >
      {docCards.map((card) => (
        <DocCard key={card.title} title={card.title} items={card.items} />
      ))}
    </Box>
  </Box>
);

export default memo(DocumentChecklistCard);
